import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import { setNewKidData } from "../../AxiosRtk/AddNewChild";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import { AlertModal } from "../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../setup/alert/iconTypes";
import { useHistory } from "react-router-dom";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { setupEmergencyPincode } from "../../AxiosRtk/PinCode";
import { getter } from "../../../../utils/storage";

const ConnectChildDevice = ({ isKidEdit }) => {
  const { getLangTranslation } = useLangTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loader, setLoader] = useState(true);
  const [qrcode, setQrCode] = useState(null);
  const [kidName, setKidName] = useState("");
  const { newKidData } = useSelector(({ addNewChild }) => addNewChild);
  const { selectedKidId, kidList } = useSelector(({ dashboard }) => dashboard);

  function generateQRCode() {
    let code = Math.ceil(Math.random() * Math.pow(10, 6));
    while (code.toString().length !== 6) {
      code = Math.ceil(Math.random() * Math.pow(10, 6));
    }
    setQrCode(code);
  }

  useEffect(() => {
    setKidName(kidList?.find((item) => item.ID === selectedKidId)?.childName);
    generateQRCode();
  }, []);

  useEffect(() => {
    if (qrcode) {
      setLoader(true);
      const kidId = newKidData ? newKidData[0]?.ID : selectedKidId;
      const accessToken = getter("kidoProtectUserAccessToken");
      setupEmergencyPincode({
        kidId,
        deviceAttachPin: qrcode,

        deviceAttachQrCode: qrcode.toString(),
        accessToken
      })
        .then((res) => { })
        .catch((err) => {
          console.log(
            "setup device attahed pincode catch error ==>>",
            err?.response?.data?.message
          );
          AlertModal(
            err?.response?.data?.message,
            alertIconType?.errorIcon,
            true
          );
        })
        .finally(() => {
          setLoader(false);
        });
    }
  }, [qrcode]);

  useEffect(() => {
    if (newKidData) {
      setKidName(
        kidList?.find((item) => item.ID === newKidData[0]?.ID)?.childName
      );
    }
  }, [newKidData]);

  function handleContinue() {
    if (isKidEdit === 1) {
      history.push("/setup-wizard");
    } else {
      history.push("/setup-wizard");
      dispatch(setNewKidData(null));
    }
  }

  function handleCancel() {
    if (isKidEdit === 1) {
      history.push("/dashboard");
    } else {
      history.push("/dashboard");
      dispatch(setNewKidData(null));
    }
  }

  if (loader) {
    return <LoadingIndicator height={20} width={100} color="#66B5FF" />;
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="content-550 mx-auto">
          <h2 className="text-center mb-6">
            {getLangTranslation(
              "CONNECT_KID_DEVICE_TITLE",
              "Connect kid`s device"
            )?.replace('kid', kidName)}
          </h2>
          <div className="mb-6">
            <label htmlFor="device" className="form-label">
              {getLangTranslation(
                "CHILD_DEVICE_USE_TEXT",
                "What kind of device does your child use?"
              )}
            </label>
            <select
              className="form-select"
              id="device"
              aria-label="Default select example"
            >
              <option value="">Select</option>
              <option value="ANDROID">
                {getLangTranslation("DOWNLOAD_APP_ANDROID", "Android")}
              </option>
              <option value="IOS">
                {getLangTranslation("DOWNLOAD_APP_IOS", "IOS")}
              </option>
            </select>
          </div>
          <h5 className="text-small text-uppercase text-gray mb-2">
            {getLangTranslation("CONNECT_DEVICE_METHOD_1", "Method 1:")}
          </h5>
          <p className="mb-6 text-small text-blue-800">
            {getLangTranslation(
              "CONNECT_DEVICE_METHOD_1_DESC",
              "Use your kid's phone or Pad to scan the QR code below to complete the installation and pairing of FamiSafe Jr;"
            )}
          </p>
          <div className="d-flex flex-column align-items-center">
            <QRCode
              value={qrcode.toString()}
              size={150}
              viewBox={`0 0 150 150`}
            />
            <h5 className="text-small text-uppercase text-gray mt-3 mb-6">
              {getLangTranslation(
                "CONNECT_DEVICE_SCAN_QR_CODE",
                "Scan QR code"
              )}
            </h5>
          </div>
          <h5 className="text-small text-uppercase text-gray mb-2">
            {getLangTranslation("	CONNECT_DEVICE_METHOD_2", "Method 2:")}
          </h5>
          <p className="mb-6 text-small text-blue-800">
            {getLangTranslation(
              "CONNECT_DEVICE_METHOD_2_DESC",
              "Download FamiSafe Jr from the App Store or Google Play of your kid's phone or pad, then open it and enter the code below to complete the pairing."
            )}
          </p>
          <div className="otp-box mb-6">
            <h3 className="mb-0 text-center">{qrcode}</h3>
            <span className="otp-box-icon">
              <i
                className="icon-refresh c-pointer"
                onClick={() => generateQRCode()}
              />
            </span>
          </div>
          {qrcode && (
            <div className="grid gap-3">
              <button className="btn btn-outline-primary g-col-6" type="button">
                <span className="btn-upper-case" onClick={handleCancel}>
                  {getLangTranslation("CANCEL", "Cancel")}
                </span>
              </button>
              <button className="btn btn-primary g-col-6" type="button">
                <span className="btn-upper-case" onClick={handleContinue}>
                  {getLangTranslation("CONTINUE", "Continue")}
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectChildDevice;
